import { WrapRootElement } from './wrap-root-element';
import { withAssetPrefix } from 'gatsby-link';
import ReactDOM from 'react-dom';
import i18n from 'i18next';
import { i18nConfig } from '@mdc/constants';
import { initReactI18next } from 'react-i18next';
import {
    AngularRedirectService,
    localStorage,
    moment,
    Authenticator,
    QueryParams,
    objectToURLParamsStr,
    StatusPageService,
    logService
} from '@mdc/services';
import '@mdc/styles/node_modules/bootstrap/scss/bootstrap.scss';

const { ENVIRONMENT } = process.env;
const HOST_NAME = {
    'local': 'metadefender.local',
    'dev': 'mcl-dev.opswat.com',
    'qa': 'mcl-qa.opswat.com',
    'prod': 'metadefender.opswat.com'
};

const i18nLocalConfig = {
    saveMissing: false,
    backend: {
        loadPath: withAssetPrefix('/locale/{{lng}}/{{ns}}.json')
    }
};

const i18nConfiguration = Object.assign({}, i18nConfig, i18nLocalConfig);
const i18nPromise = i18n
    .use(initReactI18next)
    .init(i18nConfiguration);

export const wrapRootElement = ({ element }) => {
    return WrapRootElement({ element }, i18n);
};

export const replaceHydrateFunction = () => {
    const DOMelement = document.getElementById('___mdc');
    return async (element, container, callback) => {
        await i18nPromise;
        ReactDOM.hydrate(element, DOMelement, callback);
    };
};

export const onRouteUpdate = ({ location }) => {
    const redirectUrl = AngularRedirectService.getRedirectUrl(location.href);
    if (redirectUrl) {
        window && window.location.replace(redirectUrl);
        return;
    }

    const currentLang = i18n.language;
    const currentLangParamObj = { lang: currentLang.split('-')[0] };
    const path = location.pathname.split('/');
    path.shift();
    const qParams = Object.assign({}, QueryParams(), currentLangParamObj);

    if (typeof window !== 'undefined' && typeof location === 'object' && location.host && HOST_NAME[ENVIRONMENT] === location.host) {
        window && window.history.replaceState('', '', `?${objectToURLParamsStr(qParams)}`);
    }
};

export const onClientEntry = () => {
    const currentUrl = window.location.href;
    const redirectUrl = AngularRedirectService.getRedirectUrl(currentUrl);
    if (redirectUrl) {
        window.location.href = redirectUrl;
    }
};

export const onInitialClientRender = () => {
    Authenticator.init();
    StatusPageService.getIncident();
    const gatsbyWrapperDom = document.getElementById('gatsby-focus-wrapper');
    if (gatsbyWrapperDom) {
        gatsbyWrapperDom.setAttribute('id', 'mdc-focus-wrapper');
    }

    let currentLang = localStorage.getItem('locale');
    if (!currentLang) {
        let userLang = navigator.language || navigator.userLanguage;
        currentLang = 'en-US';

        if (userLang && userLang === 'ja-JP') {
            currentLang = 'ja-JP';
        }
    }
    i18n.changeLanguage(currentLang.replace('/_/g', '-'));
    moment.locale(currentLang.split('-')[0]);
};

export const registerServiceWorker = () => {
    if ('serviceWorker' in navigator) {
        const SW_URL = '/sw.js';
        window.addEventListener('load', async () => {
            try {
                await navigator.serviceWorker.register(SW_URL);
            } catch (error) {
                logService.error(error);
            }
        });
    }
};
